<template>
  <div class="entry-layout-menus-item" :class="{ 'entry-layout-menus-item--active': activeKey === menu.key }">
    <div class="entry-layout-menus-item__hd">
      <div class="entry-layout-menus-item__title">
        <img v-if="menu.icon && ~menu.icon.indexOf('http')" class="entry-layout-menus-item__thumb" :src="menu.icon" />
        <icon-font v-else-if="menu.icon && ~menu.icon.indexOf('gb-icon-')" class="entry-layout-menus-item__thumb" :type="menu.icon" />
        <a-icon v-else class="entry-layout-menus-item__thumb" :type="menu.icon || 'thunderbolt'" />
        <span>{{ menu | menuLocalName }}</span>
      </div>
    </div>
    <div class="entry-layout-menus-item__bd">
      <template v-if="menu.childMenus.filter(item => item.lastMenu === 2).length">
        <div class="entry-layout-menus-item__children">
          <template v-for="level2 in menu.childMenus.filter(item => item.lastMenu === 2 && (paidPageFlag === 2 ? true : item.updateFlag === 1))">
            <div class="entry-layout-menus-item__text entry-layout-menus-item__text--link" :key="level2.key">
              <div class="entry-layout-menus-item__text--link__icon" v-if="level2['icon']">
                <img v-if="/^http/.test(level2['icon'])" :src="level2['icon']">
                <icon-font v-else-if="/^gb/.test(level2['icon'])" :type="level2.icon" />
                <a-icon v-else :type="level2.icon" />
              </div>
              <span @click="level2.updateFlag === 1 && onClick(level2.key)" :class="{'text-disabled': level2.updateFlag === 2 }">{{ level2 | menuLocalName }}</span>
              <template v-if="level2.updateFlag === 1">
                <a-icon v-if="~favoriteKeys.indexOf(level2.key)" type="star" theme="filled" style="display:block;color:#5681F4;" v-demo:[level2.key]="'delFavorites'" />
                <a-icon v-else type="star" v-demo:[level2.key]="'addFavorites'" />
              </template>
              <a-button class="buy-btn" v-else type="link" size="small" style="font-size: 12px; padding: 0" v-demo:[level2]="'toUpgradePage'">{{ $t('layouts.buy') }}</a-button>
            </div>
          </template>
        </div>
      </template>

      <template v-for="level2 in menu.childMenus.filter(item => item.lastMenu !== 2)">
        <div class="entry-layout-menus-item__children" :key="level2.key">
          <div class="entry-layout-menus-item__text entry-layout-menus-item__text--blod">
            <span>{{ level2 | menuLocalName }}</span>
          </div>
          <template v-for="level3 in level2.childMenus.filter(item => paidPageFlag === 2 ? true : item.updateFlag === 1)">
            <template v-if="level3.lastMenu === 2">
              <div class="entry-layout-menus-item__text entry-layout-menus-item__text--link" :key="level3.key">
                <div class="entry-layout-menus-item__text--link__icon" v-if="level3.lastMenu === 2 && level3['icon']">
                  <img v-if="/^http/.test(level3['icon'])" :src="level3['icon']">
                  <icon-font v-else-if="/^gb/.test(level3['icon'])" :type="level3.icon" />
                  <a-icon v-else :type="level3.icon" />
                </div>
                <span @click="onClick(level3.key)" :class="{'text-disabled': level3.updateFlag === 2 }">{{ level3 | menuLocalName }}</span>
                <template v-if="level3.updateFlag === 1">
                  <a-icon v-if="~favoriteKeys.indexOf(level3.key)" type="star" theme="filled" style="display:block;color:#5681F4;" v-demo:[level3.key]="'delFavorites'" />
                  <a-icon v-else type="star" v-demo:[level3.key]="'addFavorites'" />
                </template>
                <a-button class="buy-btn" v-else type="link" size="small" style="font-size: 12px; padding: 0" v-demo:[level3]="'toUpgradePage'">{{ $t('layouts.buy') }}</a-button>
              </div>
            </template>

            <template v-else-if="level3.childMenus.length">
              <div class="entry-layout-menus-item__text" :key="level3.key">
                <span>{{ level3 | menuLocalName }}</span>
                <div class="entry-layout-menus-item__children">
                  <template v-for="level4 in level3.childMenus.filter(item => paidPageFlag === 2 ? true : item.updateFlag === 1)">
                    <div class="entry-layout-menus-item__text entry-layout-menus-item__text--link" :key="level4.key">
                      <div class="entry-layout-menus-item__text--link__icon" v-if="level4.lastMenu === 2 && level4['icon']">
                        <img v-if="/^http/.test(level4['icon'])" :src="level4['icon']">
                        <icon-font v-else-if="/^gb/.test(level4['icon'])" :type="level4.icon" />
                        <a-icon v-else :type="level4.icon" />
                      </div>
                      <span @click="onClick(level4.key)" :class="{'text-disabled': level4.updateFlag === 2 }">{{ level4 | menuLocalName }}</span>
                      <template v-if="level4.updateFlag === 1">
                        <a-icon v-if="~favoriteKeys.indexOf(level4.key)" type="star" theme="filled" style="display:block;color:#5681F4;" v-demo:[level4.key]="'delFavorites'" />
                        <a-icon v-else type="star" v-demo:[level4.key]="'addFavorites'" />
                      </template>
                      <a-button class="buy-btn" v-else type="link" size="small" style="font-size: 12px; padding: 0"  v-demo:[level4]="'toUpgradePage'">{{ $t('layouts.buy') }}</a-button>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EntryLayoutMenusItem',
  props: {
    currentLang: {
      type: String,
      default: 'zh_CN'
    },
    favorites: {
      type: Array,
      default: () => []
    },
    menu: {
      type: Object,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    favoriteKeys () {
      return this.favorites.map(item => item.key)
    },
    ...mapGetters([
      'serviceId',
      'systemCode',
      'paidPageFlag'
    ])
  },
  methods: {
    onClick (key) {
      this.$emit('click', key, { statisticsType: 2, searchKey: '' })
    },
    addFavorites (key) {
      this.$store.dispatch('entry/AddFavorites', { key })
        .then(() => {
          this.$notification.success({
            message: this.$t('layouts.bookmarks.success')
          })
        })
    },
    delFavorites (key) {
      this.$store.dispatch('entry/DelFavorites', { key })
        .then(() => {
          this.$notification.success({
            message: this.$t('layouts.bookmarks.cancel')
          })
        })
    },
    toUpgradePage (menu) {
      window.open(`/#/company/serve/serve-manage/up-grade?packageId=${menu.updatePackageId}&serviceId=${this.serviceId}&systemCode=${this.systemCode}&updatePackageIds=${menu.updatePackageIds}`)
    }
  }
}
</script>

<style lang="less">
.entry-layout-menus-item {
  padding-bottom: 12px;
  display: inline-block;
  color: #333;
  position: relative;
  padding-left: 8px;
}

.entry-layout-menus-item__hd {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  position: relative;
}
.entry-layout-menus-item__thumb {
  margin-right: 5px;
  display: inline-block;
  width: 15px;
  height: 15px;
  vertical-align: middle;
}
.entry-layout-menus-item__title {
  display: flex;
  align-items: center;
  position: relative;

  > span {
    padding: 0 5px;
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &::after {
      content: " ";
      height: 10px;
      background: #5681F4;
      opacity: 0.11;
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
    }
  }
}

.entry-layout-menus-item__bd {
  display: flex;
  flex-wrap: wrap;
}
.entry-layout-menus-item__children {
  padding-left: 20px;
  padding-right: 20px;
  width: 180px;
  position: relative;

  .entry-layout-menus-item__children {
    margin-top: 5px;
    padding: 5px 10px;
    width: 100%;
    background: #F6F7FA;

    &::before {
      content: " ";
      display: block;
      width: 8.48528137px;
      height: 8.48528137px;
      border-color: #F6F7FA;
      border-style: solid;
      border-width: 4.24264069px;
      position: absolute;
      left: 14px;
      top: -4px;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
}
.entry-layout-menus-item__text {
  color: #333;
  font-size: 12px;
  line-height: 2.2;
  position: relative;

  > span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
  }

  > .anticon-star {
    display: none;
  }

  &:hover {
    > .anticon-star {
      display: block;
    }
  }
}

.entry-layout-menus-item__text--blod {
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #EEEEEE;
  font-size: 14px;
  font-weight: bold;
}
.entry-layout-menus-item__text--link {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  &:hover {
    color: #5681F4;
  }

  > span {
    flex: 1;
    min-width: 0;
    &.text-disabled {
      position: relative;
      color: #999;
      padding-right: 3px;
      &:after {
        content: "●";
        display: inline-block;
        position: relative;
        right:0px;
        top: 0;
        line-height: 1;
        border-radius: 100%;
        color: red;
        transform-origin: left center;
        transform: translate(-1px, -6px) scale(0.7);
      }
      &:hover {
        & + .buy-btn {
          line-height: 1;
          display: block
        }
      }
    }
  }
  .buy-btn {
    line-height: 1;
    display: none;
    &:hover {
      display: block
    }
  }
  &__icon {
    line-height: 1;
    position: absolute;
    max-width: 24px;
    font-size: 14px;
    top: 50%;
    transform: translate(calc(-100% - 4px), -50%);
    img {max-width: 24px;}
  }
}

.entry-layout-menus-item--active {
  .entry-layout-menus-item__hd {
    background: #5681F4;
    color: #ffffff;
  }
}

</style>
